module.exports = __webpack_public_path__ + "img/switch_qq.260cfe46.png";